import React from 'react'
import { View } from 'styles/reactnative'

import { Button, Checkbox, Input, Popover, Select, Space } from 'antd'
import TableAPI from '../../../components/TableAPI'
import { CloseOutlined, SearchOutlined } from '@ant-design/icons'
import { column_walletlist_page } from '../../../components/AdminUserModal/UserInfoTabs/column_walletlist_page'
import { column_wallet } from '../../../components/AdminUserModal/UserInfoTabs/column_wallet'
import { column_wallet_page } from '../../../components/AdminUserModal/UserInfoTabs/column_wallet_page'
import { useUserList } from '../../../hooks/user/userlist'
import { useUserGroup } from '../../../hooks/user/usergroups'
import SettingGroup from 'app/adminpages/AdminSystem/SettingGroup'

const AdminWalletHistory = ({ title, type }: any) => {
	const queryParams = new URLSearchParams(window.location.search)
	const id = queryParams.get('userid')

	const [search, setSearch] = React.useState(id || '')
	const [wallettype, setWalletType] = React.useState('')
	const [haslock, setHasLock] = React.useState(false)
	const { usertype1 } = useUserList()

	const [group, setGroup] = React.useState('*')
	const { type1 } = useUserGroup()
	return (
		<View style={{ width: '100%' }}>
			<View
				style={{
					flexDirection: 'row',
					backgroundColor: 'white',
					width: '100%',
					padding: 10,
					marginTop: 10,
					borderTopLeftRadius: 10,
					borderTopRightRadius: 10,
				}}>
				<Checkbox
					value={haslock}
					onChange={e => setHasLock(e.target.checked)}>
					동결내역 포함
				</Checkbox>
				<Select
					placeholder="계좌종류"
					filterOption={true}
					options={[
						{ value: '', label: '전체' },
						{ value: 'FEE', label: '수수료' },
						{ value: 'TRANSFER', label: '전송' },
						{ value: 'REFERRAL', label: '레퍼럴수익' },
						{ value: 'CASHDEPOSIT', label: '현금입출금' },
						{ value: 'ADMINDEPOSIT', label: '관리자입금' },
						{ value: 'ADMINWITHDRAW', label: '관리자출금' },
						{ value: 'LOCK', label: '동결' },
						{ value: 'UNLOCK', label: '동결해제' },
					]}
					value={wallettype}
					onChange={value => {
						setWalletType(value)
					}}
					style={{ width: 120, marginRight: 10 }}
				/>

				<Space.Compact direction="horizontal">
					<SettingGroup
						title={'그룹설정'}
						group={group}
						setGroup={setGroup}
						defaultv="*"
					/>
					<Popover
						placement="bottom"
						trigger={'click'}
						content={
							<Space style={{ alignItems: 'center' }}>
								<Select
									style={{ width: '100%', minWidth: 200 }}
									defaultValue={''}
									onChange={e => {
										setSearch(e)
									}}
									options={[
										{ value: '', label: '전체' },
										...(usertype1 || []),
									]}
								/>
							</Space>
						}>
						<Input
							placeholder="회원코드"
							value={search}
							onChange={e => {
								setSearch(e.target.value)
							}}
						/>
					</Popover>
					<Button
						onClick={() => {
							setSearch('')
						}}
						style={{ paddingTop: 0 }}
						size="small">
						{search ? <CloseOutlined /> : <SearchOutlined />}
					</Button>
				</Space.Compact>
			</View>
			<TableAPI
				title={title}
				columns={column_wallet_page}
				usermodal={true}
				datesearch={true}
				height={'default'}
				apikey={`/admin/history/wallet?group=${group}&${
					(search ? 'userid=' + search : 't=') +
					(wallettype
						? '&type=detail&searchWord=' + wallettype
						: '') +
					(haslock ? '&haslock=true' : '')
				}`}
			/>
		</View>
	)
}

export default React.memo(AdminWalletHistory)
